var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseLoading',{attrs:{"opaque":"","spinning":_vm.clubTeamHighlightLoading}},[_c('CollegeForm',{attrs:{"resource":_vm.clubTeamHighlight,"working-type":"edit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }